import { APIMethod, fetchData } from "@client";

export async function notifyAboutClientCommentQuery(shareLink) {
  await fetchData(`/project/m/${shareLink}`, APIMethod.POST);
}
